import Layout from '@components/Items/Filters/Layout'
import useFilter from '@components/Items/utils/hooks/useFilter'
import { FC } from 'react'
import { QUERY_KEYS, getDayOfWeek } from '@components/Items/utils/functions'
import _isArray from 'lodash/isArray'
import Checkbox from '@components/Items/components/checkbox'
import { PICKUP_DAYS_LIST } from '@components/Items/utils/constants'

const PickupDays = () => {
  const { pickupDateList, pickupDateQuery, updateQuery } = useFilter()

  // Helper to get all pickup dates for a given day
  const getDatesForDay = (day: string): string[] =>
    pickupDateList.filter((date) => getDayOfWeek(date) === day)

  // Helper to get selected pickup dates as array
  const selectedDates = Array.isArray(pickupDateQuery)
    ? pickupDateQuery
    : pickupDateQuery
    ? [pickupDateQuery]
    : []

  return (
    <Layout label={'PICKUP DAYS'}>
      <fieldset>
        <legend className="sr-only">Pickup Days</legend>
        <div className="space-y-1">
          {PICKUP_DAYS_LIST?.map((pickupDays) => {
            const datesForDay = getDatesForDay(pickupDays)
            const selectedForDay = datesForDay.filter((d) => selectedDates.includes(d))
            const isChecked = datesForDay.length > 0 && selectedForDay.length === datesForDay.length
            const isIndeterminate = selectedForDay.length > 0 && selectedForDay.length < datesForDay.length

            const handleChange = async (checked: boolean) => {
              let newSelectedDates = [...selectedDates]
              if (checked) {
                // Add all dates for this day
                newSelectedDates = Array.from(new Set([...newSelectedDates, ...datesForDay]))
              } else {
                // Remove all dates for this day
                newSelectedDates = newSelectedDates.filter((d) => !datesForDay.includes(d))
              }
              await updateQuery(QUERY_KEYS.PICKUP_DATES, newSelectedDates)
            }

            return (
              <Checkbox
                key={`pickup-days-${pickupDays}`}
                checked={isChecked}
                isIndeterminate={isIndeterminate}
                onChange={(e: any) => handleChange(e.target.checked)}
              >
                <span style={{ textTransform: 'capitalize' }}>{pickupDays}</span>
              </Checkbox>
            )
          })}
        </div>
      </fieldset>
    </Layout>
  )
}

export default PickupDays
